export enum ChainName {
  ETHEREUM = 'ETHEREUM',
  BASE = 'BASE',
  ALGORAND = 'ALGORAND',
  STELLAR = 'STELLAR'
}
